import { render, staticRenderFns } from "./HistoricoPagamento.vue?vue&type=template&id=ddb61012&scoped=true&"
import script from "./HistoricoPagamento.vue?vue&type=script&lang=js&"
export * from "./HistoricoPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb61012",
  null
  
)

export default component.exports